import axios from "axios";
import getToken from "./getToken.js";
const URL = process.env.REACT_APP_BACKEND_USER_URL;

const GetUserProfileInfo = async () => {
  const userToken = getToken();
  try {
    const response = await axios.get(URL, {
      headers: {
        token: userToken
      },
    });
    return ({
        username: response.data.user.userName,
        email: response.data.user.email,
        id: response.data.user._id
    })
  } catch (error) {
    return error;
  }
};

export default GetUserProfileInfo;
